import utility from './utility';
import Auth from './Auth';

const modules = {
  utility,
  Auth
};

// Create store
export default modules;
